import { Terminal } from "@tivic-team/manager-ts/dist/mob/entities/terminal/terminal.entity";
import { PagedResponse } from "app/interface/paged-response.interface";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environmentv3 } from "src/environments/environmentv3";
import { ApiController } from "../api-controller.interface";

export class TerminalController implements ApiController<Terminal>{
    
    constructor() { }

    find(filters ? : IFilter): Promise <Terminal[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/terminal',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<Terminal> ())
        );

        return request.call();
    }

    get(id: number): Promise <Terminal> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/terminal/:cdTerminal',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdTerminal: id
                    }),
                }),
            }),
            new HttpResponse(new Terminal())
    );

        return request.call();
    }

    create(entity: Terminal): Promise <Terminal> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/terminal',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Terminal()
            )
        );

        return request.call();
    }

    update(entity: Terminal): Promise <Terminal> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/terminal/:cdTerminal',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdTerminal: entity.cdTerminal
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Terminal()
            )
        );
        return request.call();
    }

    findTerminal(filters?: IFilter): Promise<PagedResponse<Terminal>>{
        const request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/terminal/terminais',
                    environment: environmentv3,
                    filter: filters
                })
            }),
            new HttpResponse(new Terminal())
        );
        return request.call();
      }
}